import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=7a43614c&scoped=true"
import script from "./twitter.vue?vue&type=script&lang=js"
export * from "./twitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a43614c",
  null
  
)

export default component.exports